// Awards shown on the LATAM About pages: the curated list from the LATAM
// Website Copy doc (award names stay in English in every version). Links are
// reused from the full list in ./list.js where the same award has one.
export const AWARDS_LATAM = [
  {
    year: '2026',
    awards: [
      { name: 'Logistics IT Top 100, Inbound Logistics' },
      {
        link: 'https://www.freightwaves.com/news/freightwaves-announces-2026-freighttech-100-companies',
        name: 'FreightTech 100',
      },
    ],
  },
  {
    year: '2025',
    awards: [{ name: 'FreightTech 100, FreightWaves' }],
  },
  {
    year: '2024',
    awards: [{ name: 'Top 100 Logistics IT Providers, Inbound Logistics' }],
  },
  {
    year: '2020',
    awards: [
      {
        link: 'https://www.cbinsights.com/research/artificial-intelligence-top-startups-2020/',
        name: 'Top AI 100: The Artificial Intelligence Startups - CB Insights',
      },
    ],
  },
  {
    year: '2018',
    awards: [
      {
        link: 'https://www.globenewswire.com/en/news-release/2018/09/10/1568811/0/en/Loadsmart-named-a-Cool-Vendor-by-Gartner-in-Cool-Vendors-Intelligent-Supply-Chain-Execution-Technologies-by-Gartner.html',
        name: 'Cool Vendor in Intelligent Supply Chain Execution Technologies - Gartner',
      },
    ],
  },
];
